// $('.afsz-fullimagesM').slick({
//   lazyLoad: 'ondemand',
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	arrows: true,
// 	fade: true
//   // ,dots:true
// });
let slidesToScroll_pc = 5;
let page_url_afsz = window.location.href;
if (page_url_afsz.indexOf("openmeetuc-pressure-relief-cushions") >= 0) {
  slidesToScroll_pc = 2;
}
if ($("body").hasClass("openfit2-plus-giftbox-benefits")) {
  slidesToScroll_pc = 6;
}
let fullImageSlick = $(".afsz-fullimages").slick({
  lazyLoad: "ondemand",
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  focusOnSelect: true,
  autoplay: true,
  arrows: true,
  dots: true,
  customPaging: function (slider, index) {
    console.log("slider", slider);
    return `${index + 1}/${slider.slideCount}`;
  },
  prevArrow:
    '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  asNavFor: ".afsz-thumbs",
});
let peopleFullImageSlick;
if($(".afsz-fullimages-people > .afsz-fullimages__image").length > 1) {
  peopleFullImageSlick = $(".afsz-fullimages-people").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    focusOnSelect: true,
    arrows: true,
    dots: true,
    customPaging: function (slider, index) {
      console.log("slider", slider);
      return `${index + 1}/${slider.slideCount}`;
    },
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    asNavFor: ".afsz-people-thumbs",
  });

   peopleFullImageSlick.slick('slickPause');
  $(".gallery-3d-wrapper").click(function() {
    setTimeout(() => {
    if($(this).find(".afsz-thumbs").hasClass("active")) {
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPause');
      }
      if(fullImageSlick) {
        fullImageSlick.slick('slickPlay');
      }
    }else if($(this).find(".afsz-people").hasClass("active")) {
      if(fullImageSlick) {
        fullImageSlick.slick('slickPause');
      }
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPlay');
      }
    }else if($(this).find(".afsz-video").hasClass("active")) {
      if(fullImageSlick) {
        fullImageSlick.slick('slickPause');
      }
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPause');
      }
    }
    }, 200);
    
  });

  
}

$(".afsz-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  asNavFor: ".afsz-fullimages",
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
});
$(".afsz-people-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  asNavFor: ".afsz-fullimages-people",
});

$("[data-switch]").click(function () {
  $(`[data-switch]`).removeClass("active");
  $(this).addClass("active");
  $(`[data-switch-main]`).removeClass("active");
  $(`[data-switch-main="${$(this).data("switch")}"]`).addClass("active");

  $(".afsz-prod-wrapper").removeClass("has-show-3d active-3d");
  if ($(this).data("switch") == "people") {
    if(peopleFullImageSlick) {
      peopleFullImageSlick.slick(
        "slickGoTo",
        peopleFullImageSlick.slick("slickCurrentSlide")
      );

    }
  }
  if ($(this).data("switch") == "product") {
    fullImageSlick.slick(
      "slickGoTo",
      fullImageSlick.slick("slickCurrentSlide")
    );
    $(".afsz-prod-gallery").addClass("is-product");
  } else {
    $(".afsz-prod-gallery").removeClass("is-product");
  }
});

$(".selectedVariantid").val($("#sVariantid").text());

$(".o-swatch").click(function () {
  var inp = $(this).find("input");
  var selColor = $(inp).val();
  addSelectedColorImg(selColor);
  // if($('body').hasClass('is-template-product')){
  //   document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  // }
  $(".selectedVariantid").val($("#sVariantid").text());
});

const BENEFIT_VARIANT_MAP = {
  "50761443017047": "51076489871703",
  "50761443049815": "51076489904471",
};

function switchBenefitGiftVariant(varId) {
  const targetVariantId = BENEFIT_VARIANT_MAP[String(varId)];
  if (!targetVariantId) return;

  const $images = $(".benefit-wrapper .product-wrapper .left-wrapper .variant-image-wrapper");
  const $prices = $(".benefit-wrapper .product-wrapper .right-wrapper .prices .price");

  $images.removeClass("is-active");
  $prices.removeClass("is-active");

  const $activeImage = $images
    .filter(`[data-variant-id="${targetVariantId}"]`)
    .addClass("is-active");

  const $activePrice = $prices
    .filter(`[data-variant-id="${targetVariantId}"]`)
    .addClass("is-active");

  const available = !$activeImage.hasClass("sold-out");

  $activeImage
    .closest(".product-wrapper")
    .attr("data-id", targetVariantId)
    .attr("data-available", available);

  if (!available) {
    $activeImage.closest(".product-wrapper").removeClass("active");
  } else {
    $activeImage.closest(".product-wrapper").addClass("active");
  }
}

function updateCredentialsImgVisibility(varId) {
  if (varId == "51721464152397") {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "none");
  } else {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "");
  }
}

$(".options-color-wrapper").click(function () {
  var selColor = $(this).attr("data-title");
  addSelectedColorImg(selColor);
  const varId = $(this).attr("data-var_id");
  console.log("varId::", varId);
  updateCredentialsImgVisibility(varId);
  switchBenefitGiftVariant(varId);
});

function getCurrentVariantId() {
  return (
    $(".options-color-wrapper.active").attr("data-var_id") ||
    $(".single-option-selector__radio:checked").first().attr("data-var_id") ||
    new URLSearchParams(window.location.search).get("variant") ||
    $("#sVariantid").text().trim() ||
    $(".selectedVariantid").val()
  );
}

function initBenefitGiftVariant() {
  const initVarId = getCurrentVariantId();
  if (!initVarId) return;
  updateCredentialsImgVisibility(initVarId);
  switchBenefitGiftVariant(initVarId);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBenefitGiftVariant);
} else {
  initBenefitGiftVariant();
}

if (window.jQuery) {
  window.jQuery(document).on("variantChange.productSection", () => {
    const varId = getCurrentVariantId();
    if (!varId) return;
    updateCredentialsImgVisibility(varId);
    switchBenefitGiftVariant(varId);
  });
}

var now_product_handle = $(".c-variant-selector__swatches-wrapper").attr(
  "product-handle"
);

if (
  now_product_handle == "opencomm2uc" ||
  now_product_handle == "opencomm2uc2025upgrade" ||
  now_product_handle == "openmeet"
) {
  //处理openrun加磁浮类型2uc产品无法展示橱窗图
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  sCol = sCol.replace(" ", "-/-");
  addSelectedColorImg(sCol);
} else {
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);
}

if ($(".connectivity.o-toggle .o-toggle__switch.is-active").length > 0) {
  addSelectedColorImg("USB-A");
}

function addSelectedColorImg(col) {
  let newCol = col;
  if (col.includes("+")) {
    newCol = col.split("+")[0];
  }
  if (col.includes("/")) {
    newCol = col.replace("/", "\\/");
  }

  if ($(".afsz-prod-wrapper").hasClass("fl")) {
    var selectedColor = "." + newCol;
    selectedColor = selectedColor.trim().replaceAll(" ", "-");
    // console.log(selectedColor,"selectedColor");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickFilter", selectedColor);
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);

    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
      "slickFilter",
      selectedColor
    );
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
    setTimeout(function () {
      $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);
      $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
      $(".afsz-thumbs .afsz-thumbs__thumb").click(function () {
        let now_index =
          parseInt($(this).attr("data-slick-index")) % slidesToScroll_pc;
        setTimeout(function () {
          console.log(now_index);
          $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
            "slickGoTo",
            now_index
          );
        }, 500);
      });
    }, 100);

    // $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
    //  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
    //    $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', 0);
  }
}
